import { render, staticRenderFns } from "./PolyIntegerReferenceShowScreen.vue?vue&type=template&id=75389ea6&"
import script from "./PolyIntegerReferenceShowScreen.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports